/* src/app/components/billing/claim-report/claim-report.component.css */
.ant-form-item {
  margin: 8px 0px !important;
}
/*# sourceMappingURL=claim-report.component-JMQHF4OW.css.map */
